import initVideoSlider from "./components/videoSlider.js";
import initNegativeBanner from "./components/negativeBanner.js";
import initBoxCarousel from "./components/boxCarousel.js";
import initSocialCarousel from "./components/socialCarousel.js";
import initInspiredCarousel from "./components/inspiredCarousel.js";
import initMediaCarousel from "./components/mediaCarousel.js";
import initProjectCarousel from "./components/projectCarousel.js";
import initProjectListCarousel from "./components/projectListCarousel.js";
import initNavbar from "./components/navbar.js";
import initHomeBanner from "./components/homeBanner.js";
import initBackToTop from "./components/backToTop.js";
import initModal from "./components/modal.js";
import initTab from "./components/tab.js";
import initBoxTab from "./components/boxTab.js";
import initStep from "./components/step.js";
import initStepGroupCarousel from "./components/stepGroupCarousel.js";
import initBreadcrumb from "./components/breadcrumb.js";
import initInpageNav from "./components/inpageNav.js";
import initStepTracker from "./components/stepTracker.js";
import initStateTracker from "./components/stateTracker.js";
import initTestimonialCarousel from "./components/testimonialCarousel.js";
import initFaq from "./components/faq.js";
import initFilterDisplay from "./components/filterDisplay.js";
import initDetailCarousel from "./components/detailCarousel.js";
import initTooltip from "./components/tooltip.js";
import initReadmore from "./components/readmore.js";
import initAlert from "./components/alert.js";
import initTimelineCarousel from "./components/timelineCarousel.js";
import initOrgAccordion from "./components/orgAccordion.js";
import initMenuSwiper from "./components/menuSwiper.js";
import initFloatingScroll from "./components/floatingScroll.js";
import initDropdown from "./components/dropdown.js";
import initProjectSticky from "./components/projectSticky.js";
import initCalloutScroll from "./components/calloutScroll.js";
import initContentTile from "./components/contentTile.js";
import initCardSwiper from "./components/cardSwiper.js";
import initPublicationCarousel from "./components/publicationCarousel.js";
import initRangeSlider from "./components/rangeSlider.js";
// import initTimelineMap from "./components/timelineMap.js"; // moved to custom.js (anniversary-map)
import initTimelineHorizontal from "./components/timelineHorizontal.js";
import initPublicationImagesSwiper from "./components/publicationImagesSwiper.js";
import initVimeoModal from "./components/vimeoModal.js";
import initSearchSuggestion from "./components/searchSuggestion.js";
import initSearchMegaMenu from "./components/searchMegaMenu.js";
import initInTheMaking from "./components/inTheMaking.js";
import { ScrollTrigger } from "./gsap.js";

function initDetailCharts() {
  document.querySelectorAll("[data-percent]").forEach((chart) => {
    const percent = chart.dataset.percent;
    chart.style.setProperty("--percent", percent);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  console.log("Project initialized");

  initNavbar();
  initHomeBanner();
  initVideoSlider();
  initNegativeBanner();
  initBoxCarousel();
  initSocialCarousel();
  initInspiredCarousel();
  initMediaCarousel();
  initProjectListCarousel();
  initProjectCarousel();
  initBackToTop();
  initModal();
  initTab();
  initBoxTab();
  initStep();
  initStepGroupCarousel();
  initBreadcrumb();
  initInpageNav();
  initStepTracker();
  initStateTracker();
  initTestimonialCarousel();
  initFaq();
  initFilterDisplay();
  initDetailCarousel();
  initDetailCharts();
  initTooltip();
  initReadmore();
  initAlert();
  initTimelineCarousel();
  initOrgAccordion();
  initMenuSwiper();
  initFloatingScroll();
  initDropdown();
  initProjectSticky();
  initCalloutScroll();
  initContentTile();
  initCardSwiper();
  initPublicationCarousel();
  initRangeSlider();
  initTimelineHorizontal();
  initPublicationImagesSwiper();
  initVimeoModal();
  initSearchSuggestion();
  initSearchMegaMenu();
  initInTheMaking();

  // Refresh all ScrollTriggers after everything is initialized
  // so pinned sections correctly account for each other's spacers
  requestAnimationFrame(() => {
    ScrollTrigger.sort();
    ScrollTrigger.refresh();
  });
});
